// extracted by mini-css-extract-plugin
export default {"mainNav":"Header_mainNav__laPjF","logo":"Header_logo__UsziS","mobileLogo":"Header_mobileLogo__4SiFz","navLink":"Header_navLink__jN4KB","mobileMenu":"Header_mobileMenu__bIYn6"};